var _path, _path2, _rect, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouthServiceMadded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M38.0355 13.3034L30.191 4.94898H20.3983C20.2271 4.94898 20.0565 4.97097 19.8909 5.01442L17.984 5.51458C17.5743 5.62202 17.2094 5.85673 16.9417 6.18489L16.3877 6.86398C16.0965 7.22096 15.9374 7.66753 15.9374 8.12823L15.9374 32.4967L15.6628 34.8514L18.012 36.1526L33.1689 36.6286L35.7564 35.5261L38.0355 32.7791V13.3034Z",
    fill: "url(#paint0_linear_4729_3453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.562 17.5276H29.1834C30.0615 17.5276 30.9036 17.8764 31.5245 18.4973C32.1453 19.1181 32.4941 19.9602 32.4941 20.8383V27.4597C32.4941 28.3377 32.1453 29.1798 31.5245 29.8007C30.9036 30.4216 30.0615 30.7704 29.1834 30.7704H22.562C21.684 30.7704 20.8419 30.4216 20.221 29.8007C19.6001 29.1798 19.2513 28.3377 19.2513 27.4597V20.8383C19.2513 19.9602 19.6001 19.1181 20.221 18.4973C20.8419 17.8764 21.684 17.5276 22.562 17.5276ZM21.4585 20.8383V21.9419H25.8727V19.7347H22.562C22.2693 19.7347 21.9886 19.851 21.7817 20.0579C21.5747 20.2649 21.4585 20.5456 21.4585 20.8383ZM21.4585 24.149V27.4597C21.4585 27.7524 21.5747 28.0331 21.7817 28.24C21.9886 28.447 22.2693 28.5633 22.562 28.5633H25.8727V24.149H21.4585ZM29.1834 28.5633C29.4761 28.5633 29.7568 28.447 29.9638 28.24C30.1707 28.0331 30.287 27.7524 30.287 27.4597V20.8383C30.287 20.5456 30.1707 20.2649 29.9638 20.0579C29.7568 19.851 29.4761 19.7347 29.1834 19.7347H28.0799V28.5633H29.1834ZM19.2513 2.07764C17.4952 2.07764 15.811 2.77525 14.5693 4.017C13.3275 5.25876 12.6299 6.94294 12.6299 8.69904V30.7704C12.6299 32.5265 13.3275 34.2107 14.5693 35.4524C15.811 36.6942 17.4952 37.3918 19.2513 37.3918H32.4941C34.2502 37.3918 35.9344 36.6942 37.1762 35.4524C38.4179 34.2107 39.1155 32.5265 39.1155 30.7704V14.2963C39.1156 13.4265 38.9444 12.5652 38.6115 11.7615C38.2786 10.9579 37.7906 10.2278 37.1755 9.6128L31.5804 4.01992C30.9656 3.40436 30.2355 2.91599 29.4319 2.58272C28.6283 2.24945 27.7668 2.07782 26.8968 2.07764H19.2513ZM14.837 8.69904C14.837 7.52831 15.3021 6.40552 16.13 5.57768C16.9578 4.74985 18.0806 4.28477 19.2513 4.28477H26.8968C27.4769 4.28461 28.0512 4.39875 28.5871 4.62067C29.123 4.8426 29.6099 5.16796 30.0199 5.57815L35.615 11.1732C36.0252 11.5833 36.3506 12.0702 36.5725 12.6061C36.7944 13.142 36.9086 13.7163 36.9084 14.2963V30.7704C36.9084 31.9411 36.4433 33.0639 35.6155 33.8918C34.7877 34.7196 33.6649 35.1847 32.4941 35.1847H19.2513C18.0806 35.1847 16.9578 34.7196 16.13 33.8918C15.3021 33.0639 14.837 31.9411 14.837 30.7704V8.69904Z",
    fill: "url(#paint1_linear_4729_3453)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 3.86214,
    y: 2.07764,
    width: 6.40726,
    height: 34.5509,
    rx: 1,
    fill: "url(#paint2_linear_4729_3453)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5962 13.5946H8.54459M10.5962 7.83612H7.51877M10.5962 19.3531H7.51877M10.5962 30.8701H7.51877M10.5962 25.1116H8.54459M10.5962 34.4691C10.5962 35.6611 10.071 36.6285 9.42371 36.6285H3.5622C2.91491 36.6285 2.38969 35.6611 2.38969 34.4691V3.99713C2.38969 3.48805 2.49776 2.99982 2.69014 2.63984C2.88252 2.27987 3.14344 2.07764 3.4155 2.07764H9.42371C10.071 2.07764 10.5962 3.04506 10.5962 4.23707V34.4691Z",
    stroke: "url(#paint3_linear_4729_3453)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4729_3453",
    x1: 15.6628,
    y1: 20.7888,
    x2: 38.0355,
    y2: 20.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4729_3453",
    x1: 12.6299,
    y1: 19.7347,
    x2: 39.1155,
    y2: 19.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4729_3453",
    x1: 3.86214,
    y1: 19.3531,
    x2: 10.2694,
    y2: 19.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4729_3453",
    x1: 6.49295,
    y1: 2.07764,
    x2: 6.49296,
    y2: 36.6285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB52B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouthServiceMadded);
export default __webpack_public_path__ + "static/media/youthServiceMadded.10e6664b834ae6c1ff065ac09d01ece3.svg";
export { ForwardRef as ReactComponent };